module.exports = __webpack_public_path__ + "static/media/6298.4c5fccbc.svg";